const local = window.location.origin;
export default {
  baseUrl: 'http://localhost:9999/portal-biz/',
  serviceUrl: 'http://localhost:8888/service/',
  platformsvc: 'http://localhost:8888/platformsvc/',
  // 登录回跳地址
  // redirectUrl: 'http://localhost:9999/portalUI/',// 本地
  // redirectUrl: 'https://auth-test.gczx.com:8443/portalUI/',// 线上
  redirectUrl: local + '/',

};
